import { dropEmptySections } from '../../../puck/fields/puckSectionField';

/**
 * Le Bloc porte toute la disposition parce qu'il touche la page : sa gouttière
 * mesure la distance aux bords, son animation se déclenche quand la page
 * défile, son espace inférieur le sépare du Bloc suivant, sa visibilité décide
 * de sa présence sur le site.
 *
 * Posé dans un bloc hôte (un onglet), il ne touche plus la page : ces réglages
 * n'ont plus de référent, et l'hôte porte les siens. Les laisser afficherait
 * des contrôles sans effet, ou en double avec ceux de l'hôte.
 *
 * La marge horizontale, elle, RESTE : l'hôte pose sa propre largeur, et on veut
 * pouvoir retrancher le contenu d'un onglet à l'intérieur. Elle naît juste à
 * zéro (cf. `buildTabSection`), l'hôte cadrant déjà.
 */

/** Champs du Bloc qui n'existent que par sa proximité avec la page. */
export const PAGE_EDGE_SECTION_FIELDS = [
  // Doublon avec la visibilité de l'hôte, et masquer l'unique Bloc d'un onglet
  // laisserait un onglet cliquable et vide.
  'isVisible',
  // Les panneaux sont tous montés d'un coup : l'animation d'un onglet masqué
  // se jouerait sans être vue, et ne se rejouerait jamais à l'ouverture.
  'appearAnimation',
  'appearAnimationDuration',
  // Rien ne suit le Bloc dans un onglet.
  'marginBottom',
];

/** Blocs qui hébergent un Bloc dans une de leurs zones. */
const HOST_BLOCK_TYPES = new Set(['TabsBlock']);

export function isHostedSection(parent) {
  return !!parent?.type && HOST_BLOCK_TYPES.has(parent.type);
}

/* Puck appelle `resolveFields` à chaque changement de l'item : on rend le même
   objet pour le même jeu de champs, sinon la sidebar se reconstruirait. */
const filteredCache = new WeakMap();

/**
 * Champs à afficher pour ce Bloc. Hors bloc hôte, l'objet reçu est rendu tel
 * quel (identité préservée).
 */
export function sectionFieldsForParent(fields, parent) {
  if (!fields || !isHostedSection(parent)) return fields;
  const cached = filteredCache.get(fields);
  if (cached) return cached;
  const filtered = dropEmptySections(Object.fromEntries(
    Object.entries(fields).filter(([name]) => !PAGE_EDGE_SECTION_FIELDS.includes(name)),
  ));
  filteredCache.set(fields, filtered);
  return filtered;
}
